import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { ServiceArea } from '../components/ServiceArea';
import { Testimonials } from '../components/Testimonials';
import { CtaBanner } from '../components/CtaBanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-161">
      <Header data-id="element-162" />
      <main className="flex-grow" data-id="element-163">
        <Hero data-id="element-164" />
        <Services data-id="element-165" />
        <WhyUs data-id="element-166" />
        <ServiceArea data-id="element-167" />
        <Testimonials data-id="element-168" />
        <CtaBanner data-id="element-169" />
      </main>
      <Footer data-id="element-170" />
    </div>;
}